import { Tooltip } from '@components/organism/common/Tooltip.jsx'
import { useTooltip } from '@hooks/useTooltip.js'
import { useTranslation } from 'react-i18next'

export const SectionTitle = ({
  title,
  time = '',
  className = '',
  description = false,
  descriptionText = '',
  tooltip = false,
  tooltipKey = '',
  descStyle = ''
}) => {
  const { t } = useTranslation()
  const { activeKey, toggleKey, close } = useTooltip()
  return (
    <div className={className}>
      <div className={'flex items-center justify-between'}>
        <div className={'flex items-center gap-8 leading-none'}>
          <h2 className={'text-20 text-navy-900 font-bold'}>{title}</h2>
          {tooltip && (
            <Tooltip
              tooltipKey={tooltipKey}
              activeKey={activeKey}
              onToggle={toggleKey}
              onClose={close}
            />
          )}
        </div>
        {time !== '' && (
          <span className="text-14 text-navy-400 shrink-0 whitespace-nowrap">
            {t('common.baseTimeLabel', { time })}
          </span>
        )}
      </div>
      {description && (
        <span className={`text-14 text-navy-400 ${descStyle}`}>{descriptionText}</span>
      )}
    </div>
  )
}
